import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

import Login from '@/views/system/login'
//import Index from '@/views/system/index/index'


//默认路由集合 
export const constantRouterMap = [
	{
		path: '/screen/FrmMonitor',
		component: () => import('@/views/screen/FrmMonitor'),
		name: 'FrmMonitor',
		meta: { title: 'index', icon: 'index', affix: true }
  },
  {
    path: '/screen/FrmMonitorForID',
    component: () => import('@/views/screen/FrmMonitorForID'),
    name: 'FrmMonitorForID',
    meta: { title: 'index', icon: 'index', affix: true }
  },
  {
    path: '/baseData/FrmRegionSetup',
    component: Layout,
    redirect: '/baseData/FrmRegionSetup',
    children: [
      {
        path: '',
        component: () => import('@/views/BaseData/FrmRegionSetup'),
        name: 'FrmRegionSetup',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },
  {
    path: '/baseData/FrmUserSetup',
    component: Layout,
    redirect: '/baseData/FrmUserSetup',
    children: [
      {
        path: '',
        component: () => import('@/views/BaseData/FrmUserSetup'),
        name: 'FrmUserSetup',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },
  {
    path: '/baseData/FrmHospitalSetup',
    component: Layout,
    redirect: '/baseData/FrmHospitalSetup',
    children: [
      {
        path: '',
        component: () => import('@/views/BaseData/FrmHospitalSetup'),
        name: 'FrmHospitalSetup',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },
  {
    path: '/baseData/FrmReportFileManage',
    component: Layout,
    redirect: '/baseData/FrmReportFileManage',
    children: [
      {
        path: '',
        component: () => import('@/views/BaseData/FrmReportFileManage'),
        name: 'FrmReportFileManage',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/baseData/FrmOrderSetup',
    component: Layout,
    redirect: '/baseData/FrmOrderSetup',
    children: [
      {
        path: '',
        component: () => import('@/views/BaseData/FrmOrderSetup'),
        name: 'FrmOrderSetup',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/interfince/FrmInterfinceSetup',
    component: Layout,
    redirect: '/interfince/FrmInterfinceSetup',
    children: [
      {
        path: '',
        component: () => import('@/views/interfince/FrmInterfinceSetup'),
        name: 'FrmInterfinceSetup',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },
  {
    path: '/interfince/FrmInterfinceInfo',
    component: Layout,
    redirect: '/interfince/FrmInterfinceInfo',
    children: [
      {
        path: '',
        component: () => import('@/views/interfince/FrmInterfinceInfo'),
        name: 'FrmInterfinceInfo',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/biz/FrmReport',
    component: Layout,
    redirect: '/biz/FrmReport',
    children: [
      {
        path: '',
        component: () => import('@/views/biz/FrmReport'),
        name: 'FrmReport',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/biz/FrmLoginCount',
    component: Layout,
    redirect: '/biz/FrmLoginCount',
    children: [
      {
        path: '',
        component: () => import('@/views/biz/FrmLoginCount'),
        name: 'FrmLoginCount',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/biz/FrmOrderCount',
    component: Layout,
    redirect: '/biz/FrmOrderCount',
    children: [
      {
        path: '',
        component: () => import('@/views/biz/FrmOrderCount'),
        name: 'FrmOrderCount',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/biz/FrmReportCount',
    component: Layout,
    redirect: '/biz/FrmReportCount',
    children: [
      {
        path: '',
        component: () => import('@/views/biz/FrmReportCount'),
        name: 'FrmReportCount',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/biz/FrmSpecTrans',
    component: Layout,
    redirect: '/biz/FrmSpecTrans',
    children: [
      {
        path: '',
        component: () => import('@/views/biz/FrmSpecTrans'),
        name: 'FrmSpecTrans',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/FrmSendNotice',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import('@/views/notice/FrmSendNotice'),
        name: 'FrmSendNotice',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },

  {
    path: '/index',
    component: Layout,
    redirect: '/biz/FrmReport',
    children: [
      {
        path: '',
        //component: Index,
        component: () => import('@/views/biz/FrmReport'),
        name: 'Index',
        meta: { title: 'index', icon: 'index', affix: true }
      }
    ]
  },
  {
    path: '/',
    name: '登录',
    component: Login
  }
]


export default new Router({
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js